module.exports = __webpack_public_path__ + "assets/img/svg/socials/WhatsAppVectop.svg?v=1749027885495";